import React from "react";
import { Link } from "react-router-dom";

const AboutPage = () => {
  return (
    <main className="min-h-screen bg-bookish-cream text-bookish-royal px-4 sm:px-6 py-10 sm:py-16 flex flex-col items-center">
      <div className="w-full max-w-3xl text-center">
        <h1 className="text-4xl md:text-6xl font-fancy text-bookish-royal mb-6">
          About The Bookish Circle
        </h1>
        <p className="text-lg mb-6 text-bookish-purpleAccent">
          A welcoming home for independent voices, curious readers, and bookish adventures across genres.
        </p>

        <div className="space-y-8 text-left text-base leading-relaxed text-bookish-royal">
          <section aria-labelledby="author-space">
            <h2 id="author-space" className="font-serif text-2xl font-semibold mb-2">A space for your stories</h2>
            <p>Bring your books, introduction, blog, and newsletter signup together on your author website. Make it a place where readers can discover your work and return for your next chapter.</p>
          </section>
          <section aria-labelledby="book-sales">
            <h2 id="book-sales" className="font-serif text-2xl font-semibold mb-2">Books, on your terms</h2>
            <p>Choose your book formats, set prices, and manage stock for direct sales, or link readers to other retailers. Connect Stripe for direct payments and use your portal to review orders. Your Stripe dashboard provides payment and payout details.</p>
          </section>
          <section aria-labelledby="reader-connections">
            <h2 id="reader-connections" className="font-serif text-2xl font-semibold mb-2">Connections beyond the last page</h2>
            <p>Readers can explore genres, follow authors, and save books for their next read. Your blog and newsletter offer ways to share updates and keep those connections growing.</p>
          </section>
          <section aria-labelledby="shared-circle">
            <h2 id="shared-circle" className="font-serif text-2xl font-semibold mb-2">Many genres. One Circle.</h2>
            <p>Every reader brings different interests, and every author brings a distinct voice. The Bookish Circle makes room for that variety, helping independent books find the readers who will love them.</p>
          </section>
        </div>

        <nav aria-label="About page navigation" className="mt-10 flex flex-wrap justify-center items-center gap-4">
          <Link
            to="/authorportal/mainpage"
            className="inline-flex min-h-[44px] items-center bg-bookish-purple text-white px-6 py-3 rounded-md hover:bg-bookish-purpleAccent transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-bookish-purple"
          >
            Back to Author Portal
          </Link>
          <Link to="/authorportal/mailcenterpageuc" className="inline-flex min-h-[44px] items-center px-4 py-3 underline underline-offset-4 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-bookish-purple">Contact Lady Liza</Link>
        </nav>
      </div>
    </main>
  );
};

export default AboutPage;
